import React, { useEffect, useState } from "react";
import {
  BarChartSummary,
  BarChartComparison,
  LineChartComparison
} from "../Charts";
import {
  filterData,
  processFilteredData
} from "../../utils/filterFunctions";
import "./Pages.css";

const RecuperacionAutomotoresView = ({ filters, frozenKey, filtersaux, frozenKeyaux, dates, handleFilterClick, topN, fetchWithSpinner, data, setData, comparisonYear }) => {

  const [showMode, setShowMode] = useState('Automóvil');

  const toggleMode = (mode) => {
    setShowMode(mode);
  };

  useEffect(() => {
    if (dates.start && dates.end) {
      fetchWithSpinner({
        startDate: dates.start,
        endDate: dates.end,
        year_to_compare: comparisonYear,
        endpoint: 'operatividad/recuperacionAutomotores',
      }, setData);
    }
  }, [dates.start, dates.end, showMode, comparisonYear]);

  const currentYear = dates.end ? new Date(dates.end).getFullYear() : new Date().getFullYear();

  const autos = [];
  const motos = [];

  data.forEach(item => {
    if (item.bien === "Automóvil") autos.push(item);
    else if (item.bien === "Moto") motos.push(item);
  });

  const filteredDataAutos = filterData(autos, filters);
  const autosResults = processFilteredData(filteredDataAutos, {
    includeTotals: true,
    groupByFields: ["mes", "barrio", "comuna"]
  }, comparisonYear, currentYear);
  const { totals: totalsAutos, resumenData: resumenDataAutos } = autosResults;
  const mesDataAutos = autosResults.groups.mes;
  const barrioDataRawAutos = autosResults.groups.barrio.sort((a, b) => (b[currentYear] + b[comparisonYear]) - (a[currentYear] + a[comparisonYear]));
  const barrioDataAutos = barrioDataRawAutos.slice(0, Math.min(topN, barrioDataRawAutos.length));
  const comunaDataAutos = autosResults.groups.comuna.sort((a, b) => (b[currentYear] + b[comparisonYear]) - (a[currentYear] + a[comparisonYear]));


  const filteredDataMotos = filterData(motos, filtersaux);
  const motosResults = processFilteredData(filteredDataMotos, {
    includeTotals: true,
    groupByFields: ["mes", "barrio", "comuna"]
  }, comparisonYear, currentYear);
  const { totals: totalsMotos, resumenData: resumenDataMotos } = motosResults;
  const mesDataMotos = motosResults.groups.mes;
  const barrioDataRawMotos = motosResults.groups.barrio.sort((a, b) => (b[currentYear] + b[comparisonYear]) - (a[currentYear] + a[comparisonYear]));
  const barrioDataMotos = barrioDataRawMotos.slice(0, Math.min(topN, barrioDataRawMotos.length));
  const comunaDataMotos = motosResults.groups.comuna.sort((a, b) => (b[currentYear] + b[comparisonYear]) - (a[currentYear] + a[comparisonYear]));


  const isAutoMode = showMode === 'Automóvil';

  const currentFilters = isAutoMode ? filters : filtersaux;
  const currentFrozenKey = isAutoMode ? frozenKey : frozenKeyaux;
  const nameFilter = isAutoMode ? "autos" : "motos";

  const resumenData = isAutoMode ? resumenDataAutos : resumenDataMotos;
  const diferencia = isAutoMode ? totalsAutos.diferencia : totalsMotos.diferencia;
  const variacion = isAutoMode ? totalsAutos.variacion : totalsMotos.variacion;
  const mesData = isAutoMode ? mesDataAutos : mesDataMotos;
  const barrioData = isAutoMode ? barrioDataAutos : barrioDataMotos;
  const comunaData = isAutoMode ? comunaDataAutos : comunaDataMotos;

  return (
    <div className="dashboard-grid">

      {/* Componente de Switch/Alternancia */}
      <div className="mode-selector">
        <button
          className={isAutoMode ? "active" : ""}
          onClick={() => toggleMode('Automóvil')}
        >
          🚗 Automóviles
        </button>
        <button
          className={!isAutoMode ? "active" : ""}
          onClick={() => toggleMode('Moto')}
        >
          🏍️ Motos
        </button>
      </div>

      <div className="row top">
        <div className="card small">
          <BarChartSummary
            resumenData={resumenData}
            diferencia={diferencia}
            variacion={variacion}
            xKey="name"
            title="Resumen general"
            selectedKey={currentFilters.año}
            frozenKey={currentFrozenKey}
            onBarClick={(d) => handleFilterClick("año", d?.category, "Resumen general", nameFilter)}
          />
        </div>
        <div className="card wide">
          <LineChartComparison
            showData={mesData}
            xKey="name"
            title="Recuperación por mes"
            selectedKey={currentFilters.mes}
            frozenKey={currentFrozenKey}
            onBarClick={(d) => handleFilterClick("mes", d?.category, "Recuperación por mes", nameFilter)}
          />
        </div>
      </div>
      <div className="row middle">
        <div className="column-right">
          <div className="row bottom">
            <div className="card medium">
              <BarChartComparison
                showData={barrioData}
                xKey="name"
                title="Recuperación por barrio"
                selectedKey={currentFilters.barrio}
                frozenKey={currentFrozenKey}
                onBarClick={(d) => handleFilterClick("barrio", d?.category, "Recuperación por barrio", nameFilter)}
              />
            </div>
            <div className="card wide">
              <BarChartComparison
                showData={comunaData}
                xKey="name"
                title="Recuperación por comuna"
                selectedKey={currentFilters.comuna}
                frozenKey={currentFrozenKey}
                onBarClick={(d) => handleFilterClick("comuna", d?.category, "Recuperación por comuna", nameFilter)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecuperacionAutomotoresView;